/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_ContactInputs */

const es_components_upgrade_plan_modal_contact = /** @type {(inputs: Components_Upgrade_Plan_Modal_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactanos`)
};

const en_components_upgrade_plan_modal_contact = /** @type {(inputs: Components_Upgrade_Plan_Modal_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us`)
};

/**
* | output |
* | --- |
* | "Contact us" |
*
* @param {Components_Upgrade_Plan_Modal_ContactInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_contact = /** @type {((inputs?: Components_Upgrade_Plan_Modal_ContactInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_ContactInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_contact(inputs)
	return en_components_upgrade_plan_modal_contact(inputs)
});
export { components_upgrade_plan_modal_contact as "components.upgrade_plan_modal.contact" }